import { Pickaxe, RefreshCw, WifiOff, X } from "lucide-react";

export function LoadingScreen({ error }: { error: string }) {
  return (
    <main className="loading-screen">
      <div className="loading-mark">
        <Pickaxe size={36} />
      </div>
      <h1>Breacher</h1>
      <p>{error || "正在点亮矿灯…"}</p>
    </main>
  );
}

export function FatalScreen({ error }: { error: string }) {
  return (
    <main className="loading-screen" role="alert">
      <div className="loading-mark">
        <X size={34} />
      </div>
      <h1>连接未完成</h1>
      <p>{error}</p>
      <button className="primary-command compact" onClick={() => window.location.reload()}>
        <RefreshCw size={18} />
        重新连接
      </button>
    </main>
  );
}

export function OfflineScreen({
  retrying,
  browserOnline,
  error,
  onRetry,
}: {
  retrying: boolean;
  browserOnline: boolean;
  error: string;
  onRetry: () => void;
}) {
  return (
    <main className="offline-screen" role="alert" aria-live="polite">
      <div className="offline-mark">
        <WifiOff size={42} />
      </div>
      <h1>{retrying ? "正在重新连接" : "当前处于离线状态"}</h1>
      <p>
        {error ||
          (browserOnline
            ? "游戏服务暂时不可用，本局状态已保留。"
            : "网络连接不可用，本局状态已保留。")}
      </p>
      <button className="primary-command" disabled={retrying || !browserOnline} onClick={onRetry}>
        <RefreshCw size={18} className={retrying ? "is-spinning" : ""} />
        {retrying ? "连接中…" : browserOnline ? "重新连接" : "等待网络"}
      </button>
    </main>
  );
}
